import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormHelperService } from '../../../helpers/form-helper.service';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-rental-renti-section',
    templateUrl: './property-rental-renti-section.component.html',
    styleUrls: ['./property-rental-renti-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertyRentalRentiSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    @ViewChild('propertyRentalRentiSectionForm')
    propertyRentalRentiSectionForm: NgForm;

    constructor(
        public draftFacade: DraftFacade,
        private changeDetectorRef: ChangeDetectorRef,
        private formHelperService: FormHelperService
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        this.formHelperService.validate(this.propertyRentalRentiSectionForm);
        return this.propertyRentalRentiSectionForm.form.valid;
    }

    dirty(): boolean {
        return this.propertyRentalRentiSectionForm.form.dirty;
    }
}
